var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"right-column-container landing-image",attrs:{"no-gutters":"","cols":"12","md":"8","sm":"6","order-sm":"2","role":"region","aria-label":"Informacje dla kogo jest karta mieszkańca"}})}
var staticRenderFns = []

export { render, staticRenderFns }